var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTempIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "em0drko8ua"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.662745 0 0 0 0 0.670588 0 0 0 0 0.674510 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#em0drko8ua)",
    transform: "translate(-171 -1270) translate(172 1270)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E36510",
    strokeWidth: 2,
    d: "M27.556 20.222c0 4.05-3.284 7.334-7.334 7.334s-7.333-3.284-7.333-7.334 3.283-7.333 7.333-7.333c4.05 0 7.334 3.283 7.334 7.333zM22.667 9.333L17.333 9.333 20 4zM17.333 30.667L22.667 30.667 19.999 36zM29.866 14.222L26.222 10.578 31.556 8.889zM10.579 26.222L14.222 29.866 8.889 31.556zM30.667 22.667L30.667 17.333 36 20.001zM9.333 17.333L9.333 22.667 4 20zM26.222 29.866L29.866 26.222 31.556 31.556zM14.222 10.579L10.579 14.222 8.889 8.889z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempIcon);
export default __webpack_public_path__ + "static/media/temp-icon.60f5fd6e4cd737f91a8b6ac4ed770925.svg";
export { ForwardRef as ReactComponent };